<style lang="scss" scoped>
</style>


<template>
  <div class="field">
    <label v-if="label" class="label">{{label}}</label>
    <div class="control ">
      <div class="select is-fullwidth">
        <select v-model="proxy" :disabled="disabled">
          <option disabled value="">Please select one</option>
          <option v-for="(value, name) in options" :key="value" :value="value">{{name}}</option>
        </select>
      </div>
    </div>
    <p v-for="error in errors" :key="error" class="help is-danger">
      {{error}}
    </p>
  </div>
</template>


<script>
export default {
  name: 'select-input',
  props: {
    value: null,
    options: Object,
    label: String,
    error: null,
    disabled: null
  },
  computed: {
    proxy: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    errors() {
      return Array.isArray(this.error) ? this.error : [this.error];
    }
  }
};
</script>
